<div class="c-calendar_header d-flex middle-xs">
  <div
    class="c-calendar_arrow c-calendar_arrow--prev"
    mwlCalendarPreviousView
    [view]="view"
    [(viewDate)]="viewDate"
    (viewDateChange)="viewDateChange.next(viewDate)">
    <button id="GoTo_Month_Before" aria-label="Ir al mes anterior" class="material-icons">navigate_before</button>
  </div>
  <div class="c-calendar_date">
    <h3>{{ viewDate | calendarDate: view + 'ViewTitle':locale }}</h3>
  </div>
  <div
    class="c-calendar_arrow c-calendar_arrow--next"
    mwlCalendarNextView
    [view]="view"
    [(viewDate)]="viewDate"
    (viewDateChange)="viewDateChange.next(viewDate)">
    <button id="GoTo_Month_After" aria-label="Ir al mes siguiente" class="material-icons">navigate_next</button>
  </div>
  <img src="./assets/icons/calendar.svg" alt="Icono navegación, siguiente fecha">
</div>
<br />
